export default __webpack_public_path__ + "static/media/shield4.77b4452f.svg";